import React from 'react';

const Error = ({errors}) => {
    // Remove falsy values
    const filtered = errors.filter(Boolean);
    return (
        <>
            <h2>Error:</h2>
            {filtered.map((error, key) => (
                <h3 key={key}>{error.message}</h3>
            ))}
        </>
    );
};

export default Error;
